import { useState } from 'react';

export function useForm<T = any>(initialData?: T, defaultMode: 'add' | 'edit' | 'view' = 'view') {
  const [showForm, setShowForm] = useState<boolean>(false);
  const [formMode, setFormMode] = useState<'add' | 'edit' | 'view'>(defaultMode);
  const [currentObj, setCurrentObj] = useState<T | null>(initialData || null);

  const handleCloseForm = () => {
    setShowForm(false);
  };

  const handleOpenAddForm = () => {
    setFormMode('add');
    setCurrentObj(null);
    setShowForm(true);
  };

  const handleOpenEditForm = (obj: T) => {
    setFormMode('edit');
    setCurrentObj(obj);
    setShowForm(true);
  };

  const handleOpenViewForm = (obj: T) => {
    setFormMode('view');
    setCurrentObj(obj);
    setShowForm(true);
  };

  return {
    showForm,
    formMode,
    currentObj,
    handleCloseForm,
    handleOpenAddForm,
    handleOpenEditForm,
    handleOpenViewForm
  };
}
